import { type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/utils/tailwind.util';
export const AnswerMarker = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('mt-[5px] flex size-[30px] flex-shrink-0 items-center justify-center rounded-full border-[3px] border-white shadow-xs self-start', 'bg-blue-400', className)} {...props} data-sentry-component="AnswerMarker" data-sentry-source-file="AnswerMarker.tsx">
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" className="translate-x-[1px]" viewBox="0 0 9 13" fill="none" data-sentry-element="svg" data-sentry-source-file="AnswerMarker.tsx">
        <path d="M1.25 1.25006L6.97344 6.0196C7.11737 6.13953 7.11737 6.36059 6.97344 6.48053L1.25 11.2501" stroke="white" strokeWidth="2.5" strokeLinecap="round" data-sentry-element="path" data-sentry-source-file="AnswerMarker.tsx" />
      </svg>
    </div>;
};